import { Checkbox, Avatar, Typography, styled, Box } from '@mui/material';

interface FamilyMemberStyledProps {
  $hideCheckBox?: boolean;
}

export const FamilyMemberStyled = styled('div')<FamilyMemberStyledProps>(
  ({ $hideCheckBox }) => ({
    variant: 'outlined',
    backgroundColor: 'white',
    border: '1px solid #eff0f0',
    borderRadius: '3px',
    padding: $hideCheckBox ? '8px 10px 8px 10px' : '2px 14px 2px 0',
    marginRight: '16px',
    marginBottom: '12px',

    '@media (max-width: 743px)': {
      display: 'flex',
      marginBottom: '12px',
      padding: $hideCheckBox ? '8px 16px 8px 16px' : '8px 16px 8px 0',
    },
    '@media (min-width: 744px)': {
      display: 'inline-flex',
    },
    '@media (max-width: 1199px)': {
      span: {
        display: 'flex',
        marginRight: '8px',
      },
    },
  })
);

export const FamilyMemberReadonlyStyled = styled(Box)(({ theme }) => ({
  padding: '2px 14px 2px 0',
  display: 'inline-flex',
  marginRight: 15,
  alignItems: 'center',

  [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
    '&.decIQ-member': {
      flexDirection: 'row',
      '& div:first-child': {
        alignSelf: 'flex-start',
        marginLeft: '12px',
      },
      '& p': {
        alignSelf: 'flex-start',
      },
    },
  },
}));

export const FamilyMemberCheckboxStyled = styled(Checkbox)({
  marginLeft: 0,
});

export const FamilyMemberIconStyled = styled(Avatar)({
  width: 30,
  height: 30,
  borderRadius: '50%',
  backgroundColor: '#ccc',
});

export const FamilyMemberNameContainerStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const FamilyMemberItemTextStyled = styled(Typography)({
  marginLeft: 5,
  fontSize: 14,
  textAlign: 'left',
}) as typeof Typography;
